const padL = (nr, len = 2, chr = '0') => `${nr}`.padStart(len, chr)

export const obtenerFechaHoraActual = ( ) => {
  const dt = new Date();
  const dia = padL(dt.getDate());
  const mes = padL(dt.getMonth()+1)
  const año = dt.getFullYear()
  const hora = padL(dt.getHours());
  const minuto = padL(dt.getMinutes());
  const segundo = padL(dt.getSeconds());
  return `${dia}/${mes}/${año} ${hora}:${minuto}:${segundo}`;
}
